import { ESdChangeReason } from "@kuika/kuika-cl-model";
import { PureComponent } from "react";
import { IScreenDesignContextState } from "../../contexts/screen-design-context/screen-design-context";
import { IWithSDProps, withSD } from "../../shared/hoc/screen-design-consumer";
import { triggerGlobalTooltipScan } from "./global-onboarding-tooltip-manager";

interface IScreenDesignTooltipListenerProps {}

interface IScreenDesignTooltipListenerState {
  prevScreenDesignState: IScreenDesignContextState | null;
}

const ONBOARDING_TOOLTIP_CHANGE_REASONS = new Set<ESdChangeReason>([
  ESdChangeReason.Loading,
  ESdChangeReason.DragDropDi,
  ESdChangeReason.DragDropBlock,
  ESdChangeReason.LoadProject,
  ESdChangeReason.ScreenReload,
  ESdChangeReason.ChangeSelectedDiByCanvasFrame
]);

class ScreenDesignTooltipListener extends PureComponent<
  IScreenDesignTooltipListenerProps & IWithSDProps,
  IScreenDesignTooltipListenerState
> {
  private debounceTimerRef: NodeJS.Timeout | null = null;

  constructor(props: IScreenDesignTooltipListenerProps & IWithSDProps) {
    super(props);
    this.state = {
      prevScreenDesignState: null
    };
  }

  componentDidMount() {
    this.setState({ prevScreenDesignState: this.props.sd });
    triggerGlobalTooltipScan();
  }

  componentDidUpdate(prevProps: IScreenDesignTooltipListenerProps & IWithSDProps) {
    const prevState = this.state.prevScreenDesignState;
    const currentState = this.props.sd;

    if (prevState) {
      const changeReason = (currentState as any).changeReason as ESdChangeReason;

      if (changeReason && ONBOARDING_TOOLTIP_CHANGE_REASONS.has(changeReason)) {
        triggerGlobalTooltipScan();
      } else if (
        prevState.dashboardState !== currentState.dashboardState ||
        prevState.workFlowViewLastClickedLeftPanel !== currentState.workFlowViewLastClickedLeftPanel ||
        prevState.workFlowViewLastClickedRightPanel !== currentState.workFlowViewLastClickedRightPanel ||
        prevState.dataDiagramViewLastClickedRightPanel !== currentState.dataDiagramViewLastClickedRightPanel ||
        prevState.reportDesignerViewLastClickedLeftPanel !== currentState.reportDesignerViewLastClickedLeftPanel ||
        prevState.reportDesignerViewLastClickedRightPanel !== currentState.reportDesignerViewLastClickedRightPanel ||
        prevState.designViewLastClickedLeftPanel !== currentState.designViewLastClickedLeftPanel ||
        prevState.designViewLastClickedRightPanel !== currentState.designViewLastClickedRightPanel ||
        prevState.scheduleViewLastClickedLeftPanel !== currentState.scheduleViewLastClickedLeftPanel ||
        prevState.apiManagementViewLastClickedLeftPanel !== currentState.apiManagementViewLastClickedLeftPanel ||
        prevState.designViewLastClickedRightPanel !== currentState.designViewLastClickedRightPanel
      ) {
        triggerGlobalTooltipScan();
      }
    }

    this.setState({ prevScreenDesignState: currentState });
  }

  componentWillUnmount() {
    if (this.debounceTimerRef) {
      clearTimeout(this.debounceTimerRef);
      this.debounceTimerRef = null;
    }
  }

  render() {
    return null;
  }
}

const screenDesignTooltipListener = withSD<IScreenDesignTooltipListenerProps>(ScreenDesignTooltipListener);

export { screenDesignTooltipListener as ScreenDesignTooltipListener };
